import {Action} from "@ngrx/store";
import {IResource, IResourceGroup} from "@retail-data-factory/rdf-angular-types-api";

export enum EResourcesActions {
  GetResources = '[Resources] Get Resources',
  GetResourcesSuccess = '[Resources] Get Resources Success',
  GetResourcesFailure = '[Resources] Get Resources Failure',

  TranslateResources = '[Resources] TranslateResources',

  SetCurrentResource = '[Resources] Set Current Resource',
  SetCurrentResourceSuccess = '[Resources] Set Current Resource Success',
  SetCurrentResourceFailure = '[Resources] Set Current Resource Failure',

  UpdateResource = '[Resources] Update Resource'
}
export class GetResources implements Action{
  public readonly type = EResourcesActions.GetResources;
}
export class GetResourcesSuccess implements Action{
  public readonly type = EResourcesActions.GetResourcesSuccess;
  constructor(public payload: {resources:Array<IResource>, resourceGroups:Array<IResourceGroup>}){}
}
export class GetResourcesFailure implements Action{
  public readonly type = EResourcesActions.GetResourcesFailure;
}

export class SetCurrentResource implements Action{
  public readonly type = EResourcesActions.SetCurrentResource;
  constructor(public payload: IResource){}
}
export class SetCurrentResourceSuccess implements Action{
  public readonly type = EResourcesActions.SetCurrentResourceSuccess;
  constructor(public payload: IResource){}
}
export class SetCurrentResourceFailure implements Action{
  public readonly type = EResourcesActions.SetCurrentResourceFailure;
}

export class UpdateResource implements Action{
  public readonly type = EResourcesActions.UpdateResource;
  constructor(public payload: IResource){}
}




export class TranslateResources implements Action{
  public readonly type = EResourcesActions.TranslateResources;
  constructor(public payload: string){}
}

export type ResourcesActions =
  GetResources |
  GetResourcesSuccess |
  GetResourcesFailure |

  SetCurrentResource |
  SetCurrentResourceSuccess |
  SetCurrentResourceFailure |

  UpdateResource |

  TranslateResources;
